export const sessionStorageMigrations = {
    0: (state) => {
        return state;
    },
};
